module.exports = __webpack_public_path__ + "img/light.611a6ff2.svg";